import React, { useEffect, useState, useRef } from 'react';
import { Check, X } from 'lucide-react';
import { portalApi } from '../../lib/portalApi';
import { PORTAL_APPROVALS } from '../../constants/testIds';

const PortalApprovals = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reviewingId, setReviewingId] = useState(null);
  const isReviewingRef = useRef(false);

  const load = () => {
    portalApi.get('/portal/approvals').then(({ data }) => setItems(data)).finally(() => setLoading(false));
  };

  useEffect(load, []);

  const review = async (id, status) => {
    if (isReviewingRef.current) return;
    isReviewingRef.current = true;
    setReviewingId(id);
    try {
      const { data } = await portalApi.patch(`/portal/approvals/${id}`, { status });
      if (data.publish_note) window.alert(data.publish_note);
      load();
    } catch (err) {
      window.alert(err?.response?.data?.detail || 'Something went wrong, please try again.');
    } finally {
      isReviewingRef.current = false;
      setReviewingId(null);
    }
  };

  return (
    <div data-testid={PORTAL_APPROVALS.page}>
      <h1 className="text-2xl font-extrabold text-stone-900 mb-1">Review Posts</h1>
      <p className="text-stone-500 text-sm mb-7">AI-drafted posts and replies about your business — approve what you like.</p>

      {!loading && items.length === 0 ? (
        <div data-testid={PORTAL_APPROVALS.emptyState} className="bg-white border border-dashed border-stone-300 rounded-2xl p-12 text-center">
          <p className="text-stone-500 text-sm">Nothing to review right now — new drafts will show up here.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((item) => (
            <div key={item.id} className="bg-white rounded-2xl border border-stone-200 p-5 flex items-start justify-between gap-4">
              <div>
                <p className="text-xs font-semibold text-stone-400 uppercase mb-1">{item.type.replace('_', ' ')}</p>
                <p className="text-sm text-stone-800">{item.content}</p>
              </div>
              <div className="flex gap-2 shrink-0">
                <button data-testid={PORTAL_APPROVALS.approveButton} disabled={reviewingId === item.id} onClick={() => review(item.id, 'approved')} className="p-2 rounded-lg bg-emerald-100 text-emerald-700 hover:bg-emerald-200 transition disabled:opacity-50 disabled:cursor-not-allowed">
                  <Check size={16} />
                </button>
                <button data-testid={PORTAL_APPROVALS.rejectButton} disabled={reviewingId === item.id} onClick={() => review(item.id, 'rejected')} className="p-2 rounded-lg bg-red-100 text-red-600 hover:bg-red-200 transition disabled:opacity-50 disabled:cursor-not-allowed">
                  <X size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PortalApprovals;
